import emailjs from "@emailjs/browser";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import logoSrc from "./assets/images/logo.png";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import ContactPage from "./pages/ContactPage";
import GalleryPage from "./pages/GalleryPage";
import HomePage from "./pages/HomePage";

emailjs.init("uOtsosmsmMjn3z0Xp");

function App() {
	return (
		<Router>
			<Navbar logoSrc={logoSrc} />
			<Routes>
				<Route path="/" element={<HomePage />} />
				<Route path="/gallery" element={<GalleryPage />} />
				<Route path="/contact" element={<ContactPage />} />
			</Routes>
			<Footer />
		</Router>
	);
}

export default App;
